import React, { useEffect, useState } from 'react';
import { TravelJournalArticlesType } from 'types/types';
import PopularArticleCard from '../popular-article-card';
import styles from './PopularArticles.module.scss';
import { Heading } from 'components/text';
import Container from 'components/container';

export interface PopularArticlesProps {
  articles: TravelJournalArticlesType[];
}

const PopularArticles: React.FC<PopularArticlesProps> = ({ articles }) => {
  return (
    <Container as="section">
      <Heading as={'h2'} fontSize={28} className={styles.title}>
        Popular this month
      </Heading>
      <div className={styles.articlesGrid}>
        {articles.map(article => (
          <PopularArticleCard key={article.id} article={article} />
        ))}
      </div>
    </Container>
  );
};

export default PopularArticles;
